import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";


const AdminRoute = ({allowedRoles}) => {
    const {auth} = useAuth();

    return ( 
        allowedRoles.find( role => role === auth?.role)
        ? <Outlet />
        : <Navigate to="/UnauthorizedAccess" />
    )
}

export default AdminRoute;